<template>
  <div>
    <div id="personInfo">
      <div class="infoWrap">
        
        <div class="infoItem">
          <div class="itemLeft">账号：</div>
          <div class="itemRight">
            <div class="rightInfo">{{ tel }}</div>
            <div class="rightStatus">
              <img v-if="show" src="../../../assets/images/ykh.png" alt="">
              <span :class="show ? 'spanColor' : 'noSpanColor'">{{ showText }}</span>
            </div>
          </div>
          <div v-if="showText === '已开户' && isPerson" class="itemLeft">姓名：</div>
          <div v-if="showText === '已开户' && !isPerson" class="itemLeft">姓名：</div>
          <div v-if="showText === '已开户'" class="itemRight">
            <div class="rightInfo">{{ dataList.certificateName }}</div>
          </div>
        </div>
        <div v-if="showText === '已开户'">
          <div class="infoItem">
            <div class="itemLeft">证件类型：</div>
            <div class="itemRight">
              <div class="rightInfo">身份证</div>
            </div>
            <div class="itemLeft">证件号码：</div>
            <div class="itemRight">
              <div class="rightInfo">{{ dataList.certificateNumber }}</div>
            </div>
          </div>
          <div class="infoItem">
            <div class="itemLeft">省份：</div>
            <div class="itemRight">
              <div class="rightInfo">{{ prove }}</div>
            </div>
            <div class="itemLeft">有效期开始：</div>
            <div class="itemRight">
              <div class="rightInfo">{{ dataList.certificateValidStart }}</div>
            </div>
          </div>
          <div class="infoItem">
            <div class="itemLeft">有效期结束：</div>
            <div class="itemRight">
              <div class="rightInfo">{{ dataList.certificateValidEnd }}</div>
            </div>
            <div class="itemLeft">证件地址：</div>
            <div class="itemRight">
              <div class="rightInfo">{{ dataList.certificateAddr ? dataList.certificateAddr : '--' }}</div>
            </div>
          </div>
          <div class="infoItem" v-if="!isPerson">
            <div class="itemLeft">企业名称：</div>
            <div class="itemRight">
              <div class="rightInfo">{{ dataList.licenseOrgName }}</div>
            </div>
            <div class="itemLeft">统一信用代码：</div>
            <div class="itemRight">
              <div class="rightInfo">{{ dataList.licenseSocialCreditCode }}</div>
            </div>
          </div>
          <div class="infoItem">
            <div class="itemLeft">收货地址：</div>
            <div class="itemRight">
              <div class="rightInfo">{{ dataList.informationAddress }}</div>
            </div>
            <div class="itemLeft">紧急联系人：</div>
            <div class="itemRight">
              <div class="rightInfo">{{ dataList.informationName ? dataList.informationName : '--' }}</div>
            </div>
          </div>
          <div class="infoItem">
            <div class="itemLeft">联系人电话：</div>
            <div class="itemRight">
              <div class="rightInfo">{{  dataList.informationCellphone ? dataList.informationCellphone : '--'}}</div>
            </div>
              <div class="itemLeft">{{ !isPerson ? '法人联系电话：' : ''}}</div>
              <div class="itemRight" style="border: none;" v-if="isPerson"></div>
              <div class="itemRight" v-else>
                <div class="rightInfo">{{ dataList.informationPersonCellphone ? dataList.informationPersonCellphone : '--' }}</div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*global http protocol */
import city from './city.js'
export default {
  data() {
    return {
      isPerson: true,
      showText: '未开户',
      show: false,
      tel: localStorage.getItem('myPhone'),
      prove: '',
      dataList: {},
    }
  },
  mounted() {
    this.findUserStatusProcess()
  },
  methods: {
    // 查询用户状态s
    findUserStatusProcess() {
      http.postFront(protocol.param_findUserStatusProcess).then(response => {
        const { code, value } = response.data
        if (code === 0 || code === '0') {
          if (value) {
            // 代表已开户 true   false代表未开户
            // this.isOpen = true
            if (!value.audit) {
              if (value.poro == 'O') {
                this.isPerson = false
                this.dataList = value.authentication
                const cnum = this.dataList.certificateNumber
                  ? this.dataList.certificateNumber.slice(0, 6)
                  : ''
                if (cnum) {
                  this.prove = city.fintCityNameWithCNum(cnum)
                }
                switch (value.authentication.status) {
                  case 'license': // 已上传营业执照
                    this.show = false
                    this.showText = '未开户'
                    break
                  case 'certificate': // 已上传身份证
                    this.show = false
                    this.showText = '未开户'
                    break
                  case 'information': // 已完善资料
                    // auditStatus=5 signatureQuantity=5  进人工审核
                    if (
                      value.authentication.auditStatus === 5 &&
                  value.authentication.signatureQuantity === 5
                    ) {
                      // 人工审核电子签名
                      this.show = false
                      this.showText = '未开户'
                      this.routerPath = 17
                    } else {
                      this.show = false
                      this.showText = '未开户'
                      this.routerPath = 18
                    }
                    break
                  case 'signature': // 已电子签名
                    this.show = false
                    this.showText = '未开户'
                    this.routerPath = 19
                    break
                  case 'agreement': // 已签署协议
                    this.show = false
                    this.showText = '未开户'
                    this.routerPath = 20
                    break
                  case 'success': // 已实名认证
                    this.show = true
                    this.showText = '已开户'
                    break

                  default:
                    break
                }
              } else if (value.poro == 'P') {
                this.dataList = value.authentication
                const cnum = this.dataList.certificateNumber
                  ? this.dataList.certificateNumber.slice(0, 6)
                  : ''
                  this.isPerson = true
                if (cnum) {
                  this.prove = city.fintCityNameWithCNum(cnum)
                }
                switch (value.authentication.status) {
                  case 'answer': // 已答题
                    this.show = false
                    this.showText = '未开户'
                    break
                  case 'employed': // 已上传从业证明
                    this.show = false
                    this.showText = '未开户'
                    break
                  case 'certificate': // 已上传身份证
                    this.show = false
                    this.showText = '未开户'
                    break
                  case 'information': // 已完善资料
                    // auditStatus=5 signatureQuantity=5  进人工审核
                    if (
                      value.authentication.auditStatus === 5 &&
                value.authentication.signatureQuantity === 5
                    ) {
                      this.show = false
                      this.showText = '未开户'
                      // 人工审核电子签名
                    } else {
                      this.show = false
                      this.showText = '未开户'
                    }
                    break
                  case 'signature': // 已电子签名
                    this.show = false
                    this.showText = '未开户'
                    break
                  case 'agreement': // 已签署协议
                    if (value.authentication.auditStatus === 6) {
                      // Toast('视频人工审核中')
                      // 跳转到"人工审核"
                      this.show = false
                      this.showText = '未开户'
                    } else {
                      this.show = false
                      this.showText = '未开户'
                    }
                    break
                  case 'success': // 已实名认证
                    this.show = true
                    this.showText = '已开户'
                    break
                  default:
                    break
                }
              } else if (value.poro == 'N') {
                this.show = false
                this.showText = '未开户'
                this.dataList = null
              }
            } else {
              // 已开户
              this.show = true
              this.showText = '已开户'
              this.dataList = value.authentication
              const cnum = this.dataList.certificateNumber
                ? this.dataList.certificateNumber.slice(0, 6)
                : ''
              if (cnum) {
                this.prove = city.fintCityNameWithCNum(cnum)
              }
            }
          } else {
            this.show = false
            this.showText = '未开户'
            this.dataList = null
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#personInfo {
  min-height: calc(100vh - 60px);
  background: #fff;
  .infoWrap {
    padding-top: 182px;
    .infoItem {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 19px;
      .itemLeft {
        width: 200px;
        text-align: right;
        margin-right: 10px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
      }
      .itemRight {
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        width: 300px;
        height: 20px;
        padding: 5px 31px 5px 26px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 4px;
        border: 1px solid #999999;
        .rightStatus {
          font-size: 14px;
          display: flex;
          align-items: center;
          img {
            width: 16px;
            height: 20px;
            margin-right: 9px;
          }
          .spanColor {
            color: #3370FF;
          }
          .noSpanColor {
            color: #d64040;
          }
        }
      }
    }
  }
}
</style>
